<template>
  <!-- promo codes and final price -->
  <div :class="[isBcom ? 'badges-wrapper':'']">
    <div
      v-for="badge in limitedBadges"
      :key="badge"
      class="badges"
    >
      <template v-if="!isBcom">
        <!-- TODO: check with xapi team if there is promoCode available in badges -->
        <!-- TODO: conditions to display badge header (promos) -->
        <div v-if="isPopupBadge(badge)">
          <a
            :href="`javascript:void(0);${badge?.popUp?.url}`"
            class="badgeRebate"
          >
            {{ badge?.header }}
          </a>
        </div>
        <div
          v-else
          class="badge-wrapper small"
        >
          <div
            v-if="badge?.header"
            class="badges-container"
            :class="[badge?.type ?'badge-header':'']"
          >
            <LoyaltyStarIcon
              :loyalty-badge="loyaltyBadge"
              :badge="badge"
            />
            <span
              :class="{'badge-free-gwp': isFreeGwp(badge)}"
            >{{ getBadgeTextWithoutLastWord(badge?.header) }}<span class="no-wrap">{{ getBadgeLastWord(badge?.header) }}<button
              v-if="badge?.description && !suppressToolTip && !shouldRemoveToolTip(badge)"
              v-tooltip.bottom="{
                value: getTooltipContent(badge),
                escape: true
              }"
              class="tooltip-small"
              @click.once="plpToolTipClick()"
            /></span></span>
          </div>
        </div>
      </template>
      <template v-else>
        <div
          v-if="badge?.description"
          class="eyebrow flexText"
        >
          {{ badge.description }}
        </div>
      </template>
      <span
        v-if="hasFinalOffer&&badge?.finalPrice && finalPrice(badge)?.saleValue"
        :class="{'final-offer price-reg': finalPrice?.saleType!='regular'}"
      >{{ finalPrice(badge).saleValue }}</span>
      <template v-if="hasFinalOffer && finalPriceWithRange(badge)?.saleValue">
        <span :class="{'final-offer price-reg': finalPriceWithRange?.saleType!='regular'}">
          {{ finalPriceWithRange(badge).saleValue }}</span>
      </template>
    </div>
  </div>
</template>

<script>
import Tooltip from '@atomic-ui/tooltip';
import { fireTag } from '@vue-util/tagManager';
import isBcom from '../../../utils/isBcom';
import LoyaltyStarIcon from './LoyaltyStarIcon';

export default {
  name: 'Badges',
  directives: {
    tooltip: Tooltip,
  },
  components: { LoyaltyStarIcon },
  props: {
    badges: {
      type: Array,
      default: () => [],
    },
    suppressToolTip: {
      type: Boolean,
      default: false,
    },
    loyaltyBadge: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    isSimplificationOn: {
      type: Boolean,
      default: false,
    },
    overridePriceSimplification: {
      type: Boolean,
      default: false,
    },
    removeTooltipOnFgwpBadgeEnabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isBcom,
    };
  },
  computed: {
    hasFinalOffer() {
      return this.badges.some((badge) => badge.finalPrice);
    },
    limitedBadges() {
      let filteredBadges;
      if (this.badges.length) {
        const seenBadges = new Set();
        filteredBadges = this.badges.filter((badge) => {
          const lowerCaseHeader = badge.header?.toLowerCase();
          if (!seenBadges.has(lowerCaseHeader)) {
            seenBadges.add(lowerCaseHeader);
            return true;
          }
          return false;
        });
      }
      if (filteredBadges?.length > 7) {
        return filteredBadges.slice(0, 7);
      }
      return filteredBadges || [];
    },
    // TODO ::: maybe return class names here as well
    cssBadgesWrapperSimplification() {
      return this.isSimplificationOn && !this.overridePriceSimplification ? '12px' : '8px';
    },
    cssBadgesSimplification() {
      return this.isSimplificationOn && !this.overridePriceSimplification ? '4px' : '0';
    },
  },
  methods: {
    finalPrice(badge) {
      const priceIndex = badge?.finalPrice?.label.indexOf('[PRICE]');
      const label = badge?.finalPrice?.label.substring(0, priceIndex);
      if (this.hasFinalOffer && badge?.finalPrice?.values[0].type !== 'regular') {
        return {
          saleValue: `${label}${badge?.finalPrice?.values[0].formattedValue}`,
          saleType: badge?.finalPrice?.values[0].type,
        };
      }
      return null;
    },
    finalPriceWithRange(badge) {
      if (badge?.finalPrice?.values[1]) {
        return {
          saleValue: ` - ${badge?.finalPrice?.values[1].formattedValue}`,
          saleType: badge?.finalPrice?.values[1].type,
        };
      }
      return null;
    },
    isPopupBadge(badge) {
      return badge?.popUp && badge?.popUp?.url?.includes('popupFileName');
    },
    isFreeGwp(badge) {
      return (badge?.header?.toLowerCase() === 'free gift with purchase');
    },
    getTooltipContent(badge) {
      return `
        <div class="tooltip-content">
          <div class="tooltip-content__header">${badge?.header || ''}</div>
          <div>${badge?.description || ''}</div>
        </div>
      `;
    },
    getBadgeTextWithoutLastWord(header) {
      const splittedHeader = header?.split(' ');
      splittedHeader?.pop();
      return `${splittedHeader?.join(' ')} `;
    },
    getBadgeLastWord(header) {
      const headerArr = header?.split(' ');
      return headerArr[headerArr.length - 1];
    },
    plpToolTipClick() {
      if (!isBcom) {
        fireTag('link', {
          event_name: 'plp tool tip click',
          link_name: 'plp tool tip click',
        });
      }
    },
    shouldRemoveToolTip(badge) {
      // removes tooltip from FreeGwp badges
      if (this.isFreeGwp(badge)) {
        return this.removeTooltipOnFgwpBadgeEnabled;
      }

      // removes tooltip from Loyalty badges
      const loyaltyRegex = /(star money|star rewards points)/;
      return loyaltyRegex.test(badge?.header?.toLowerCase());
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@core/csg/src/scss/encodedIcons/mcom/_tooltip-small.scss';
.badge{
  margin-bottom: rem-calc(12);
}

.badges-wrapper {
  margin-top: v-bind(cssBadgesWrapperSimplification);
  margin-bottom: 4px;
}

.badge-wrapper {
  .tooltip-small {
    vertical-align: bottom;
    background-size: 18px 18px;
    margin-left: 2px;
    height: 18px;
    width: 18px;
  }
  .no-wrap {
    white-space: nowrap;
  }
}
.badgeRebate {
  color: red;
  font-weight: 700;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    color: #000;
  }
}
</style>

<style lang="scss" brand="mcom">
  .p-tooltip.p-component .p-tooltip-text {
    white-space: normal;
    .tooltip-content {
    display: flex;
    flex-direction: column;

    &__header {
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 8px;
    }
  }
}
</style>

<style lang="scss"  brand ="mcom" scoped>
.badges{
  margin-top: rem-calc(8);
  &+.badges {
    margin-top: rem-calc(4);
  }
  .final-offer {
    color: $sale-color;
  }
}
.badge-free-gwp {
  background-color: #FCE8EA;
  padding: 2px 8px;
}

.badges-container{
  display: flex;
  span{
    align-self: center;
  }
}
</style>

<style lang="scss" brand="bcom" scoped>
.badges{
  .flexText, .newMarkdown{
    color:$gray-1-color
  }
  .loyaltyBadge{
    color:$loyalty-1-color;
  }
}
</style>
